export const LogoIcon = () => {
	return (
		<svg viewBox="0 0 234 60" fill="none">
			<path d="M0 0H57L87.5 30H30.5L0 0Z" fill="white" />
			<path d="M173 0L203.5 30H144.5L173 0Z" fill="white" />
			<path d="M203.5 30L234 60H203.5V30Z" fill="white" />
			<path d="M57.25 60H114.174L144.5 30H87.5757L57.25 60Z" fill="white" />
		</svg>
	);
};
